export const CARDS_EXTENSION_TYPE = 'com.atlassian.confluence.link-cards';
export const SPOTLIGHT_EXTENSION_TYPE = 'com.atlassian.confluence.spotlight';
export const SECTION_EXTENSION_TYPE = 'com.atlassian.confluence.hub-section';
export const RESOURCE_TILES_EXTENSION_TYPE = 'com.atlassian.confluence.knowledge-cards';
export const LINKS_MENU_EXTENSION_TYPE = 'com.atlassian.confluence.links-menu';
export const CAROUSEL_EXTENSION_TYPE = 'com.atlassian.confluence.carousel';
export const SEARCH_EXTENSION_TYPE = 'com.atlassian.confluence.company-hub-search';
export const HUB_ELEMENT_PLACEHOLDER_EXTENSION_TYPE =
	'com.atlassian.confluence.hub-element-placeholder';

export const DEFAULT_BRANDING_COLOR = '#DDDEE1';
export const HUB_PRIMARY_COLOR_CSS_VAR = '--hub-primary-color';
export const HUB_PRIMARY_TEXT_COLOR_CSS_VAR = '--hub-primary-text-color';
export const HUB_PRIMARY_LINK_COLOR_CSS_VAR = '--hub-primary-link-color';
export const HUB_LOGO_HEIGHT = '32px';
export const HUB_LOGO_HEIGHT_LEGACY = '40px'; // Pre-standardization height for CSM fallback
export const SENTRY_DSN =
	'https://db7d48b351f4e353b021f65a7a8d6928@o55978.ingest.us.sentry.io/4509310829920256';
export const UNKNOWN_TAG = 'unknown';
export const NETWORK_ERROR_CODE = 0;
